import PropTypes from "prop-types";
import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getInitials } from "../../../../util/general-helpers";
import { DashboardExport } from "../../../../assets/icons";
import { useSortableData } from "../../dashboard-util/dashboard-utils";
import ArrowDown from "../../../../assets/icons/ArrowDown.svg";
import ArrowUp from "../../../../assets/icons/ArrowUp.svg";
import ArrowHover from "../../../../assets/icons/ArrowHover.svg";

const GroupHeadDeal = React.memo(( props ) => {
    const { title, exportData, departmentTitle, tableHeaders, renderExtraColumns, showModal, exportDisabled } = props;
    const { items, requestSort, getArrowDirectionFor } = useSortableData(props.items);

    return (
        <div>
            <div className="new-dashboard table-wrapper mt-4">
                <div className="DashboardTableWrapper TechDashboard">
                    <div>
                        <div className="DashboardTableHeader">
                            <th className="DashboardTableTitle">
                                <span>{title}</span>
                                <button
                                    key="download"
                                    className={`DashboardTableHeaderButtons bg-transparent ${
                                        exportDisabled ? 'dashboard-export-button-disabled' : ''
                                    }`}
                                    onClick={exportData}
                                    onKeyDown={exportData}
                                    tabIndex="0"
                                    data-testid="export-button"
                                    disabled={exportDisabled}
                                >
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip>Export Data</Tooltip>}
                                    >
                                        <img src={DashboardExport} alt="Export" />
                                    </OverlayTrigger>
                                </button>
                                <div className="subDepartmentTitle">{departmentTitle}</div>
                            </th>
                        </div>
                        {   items.length > 0 &&
                        <div className="scrollable-dashboard">
                            <table>
                                <thead className="techHeader sticky-header-dashboard">
                                    <tr className="tableColumnTitles tableHeader">
                                        {   tableHeaders.map((header, index) => (
                                            <th key={header} className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                {   index === 0 ?
                                                    <th className="col-md-1 col-sm-1 textEllipsis headerSorted">
                                                        <div onClick={() => requestSort("GroupHeadName")} className={'sortedCenter'}>
                                                            <div className="containerTextSorted">
                                                                <p className="textSorted">{header}</p>
                                                            </div>
                                                            {   getArrowDirectionFor("GroupHeadName", "descending") &&
                                                                <img className="arrowDirection" alt="Arrow down" src={ArrowDown} />
                                                            }
                                                            {   getArrowDirectionFor("GroupHeadName", "ascending") &&
                                                                <img className="arrowDirection" alt="Arrow up" src={ArrowUp} />
                                                            }
                                                            {   getArrowDirectionFor("GroupHeadName") &&
                                                                <img className="arrowDirectionHover" alt="Arrow sort" src={ArrowHover} />
                                                            }
                                                        </div>
                                                    </th>
                                                :
                                                    <p className="textSorted">{header}</p>
                                                }
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="tableBody techBody" data-testid="table-body">
                                    {   items?.map((item) =>
                                            <tr key={item.GroupHeadName}>
                                                <td
                                                    className="col-md-1 col-sm-1 mt-2 hover"
                                                    onClick={() => showModal(item)}
                                                    data-testid={`group-head-${item.GroupHeadName}`}
                                                >
                                                    <div className="violationContainer">
                                                        <div className="violationIconContainer">
                                                            <div className={`member-icon-user d-flex align-items-center`}>
                                                                <div className={`member-icon-initials-user`}>
                                                                    {getInitials(item.GroupHeadName)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {item.GroupHeadName} {item.GroupHeadIndicator && `(${item.GroupHeadIndicator})`}
                                                    </div>
                                                </td>
                                                <td className="col-md-1 col-sm-1 mt-2"> {item.NumberOfDeals}</td>
                                                <td className="col-md-1 col-sm-1 mt-2"> {item.NumberOfAnalystsAssociates} </td>
                                                {renderExtraColumns?.(item)}                                               
                                            </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
});

GroupHeadDeal.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            GroupHeadName: PropTypes.string.isRequired,
            GroupHeadIndicator: PropTypes.string,
            NumberOfDeals: PropTypes.number.isRequired,
            NumberOfAnalystsAssociates: PropTypes.number.isRequired,
        }).isRequired
    ).isRequired,
    title: PropTypes.string.isRequired,
    exportData: PropTypes.func,
    departmentTitle: PropTypes.string.isRequired,
    tableHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
    renderExtraColumns: PropTypes.func,
    renderModal: PropTypes.func.isRequired,
    exportDisabled: PropTypes.bool,
};

export default GroupHeadDeal;
